export default __webpack_public_path__ + "static/hero-poster-desktop-8b7fbcc7a9e9430bbb08eed7cf414d85.jpg";